import React from 'react';
import { useParams } from 'react-router-dom';
import { Trash2, AlertTriangle } from 'lucide-react';

export function AgreementDeleted() {
  const { agreement_id } = useParams<{ agreement_id: string }>();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
            <Trash2 className="h-8 w-8 text-red-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Agreement Deleted
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            This agreement has been deleted and is no longer available.
          </p>
          {agreement_id && (
            <div className="bg-gray-100 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-700">
                <span className="font-medium">Agreement ID:</span> {agreement_id}
              </p>
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <AlertTriangle className="h-5 w-5 text-red-600 mt-0.5 mr-3 flex-shrink-0" />
              <div className="text-left">
                <h3 className="text-sm font-medium text-red-800 mb-1">
                  What happens now?
                </h3>
                <p className="text-sm text-red-700">
                  Deleted agreements cannot be accessed or completed. Please contact your property consultant if you believe this is an error or if you need assistance with a new agreement.
                </p>
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-600">
            <p className="mb-4">An agreement may be deleted if:</p>
            <ul className="text-left space-y-2 max-w-xs mx-auto">
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                It was cancelled by the property consultant
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                The property is no longer available
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                There were issues with the agreement details
              </li>
              <li className="flex items-start">
                <span className="text-red-500 mr-2">•</span>
                It was replaced with a new agreement
              </li>
            </ul>
          </div>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Need assistance? Contact your property consultant or support team for help regarding this deleted agreement.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}